import { pushToDataLayer } from '../gaTracker';
import { mobileAppUtil } from '../../mobileAppUtil';
export var search = function search(search_term) {
  if (!(mobileAppUtil === null || mobileAppUtil === void 0 ? void 0 : mobileAppUtil.isMobileApp())) {
    var ecommerceObj = {
      event: 'search',
      detailed_event: 'Search',
      event_data: {
        search_term: search_term
      }
    };
    pushToDataLayer(ecommerceObj);
  }
};